import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  DateField,
  ReferenceField,
  EditButton,
  DeleteButton,
  CreateButton,
  TopToolbar,
  useRecordContext,
} from 'react-admin';
import { Chip } from '@mui/material';
import { createEmptyStateComponent } from '../../components/withCustomEmptyState';
import { PageWrapper } from '../../components/PageWrapper';

const StatusField = () => {
  const record = useRecordContext();
  if (!record?.status) return null;
  
  const getColor = (status: string) => {
    switch (status.toLowerCase()) {
      case 'completed': return 'success';
      case 'in_progress': return 'warning';
      case 'pending': return 'info';
      default: return 'default';
    }
  };
  
  return (
    <Chip 
      label={record.status} 
      color={getColor(record.status)}
      size="small"
    />
  );
};

const ListActions = () => (
  <TopToolbar>
    <CreateButton />
  </TopToolbar>
);

const DriverEducationEmptyState = createEmptyStateComponent(
  'driver-education',
  undefined,
  {
    title: 'No Driver Education Records',
    subtitle: 'Education and training records will appear here when drivers complete their education information.',
    hideAction: true,
  }
);

export const DriverEducationList = () => (
  <PageWrapper title="Driver Education">
    <List
      perPage={25}
      sort={{ field: 'id', order: 'DESC' }}
      actions={<ListActions />}
      empty={<DriverEducationEmptyState />}
    >
      <Datagrid>
        <TextField source="id" />
        <ReferenceField source="driverId" reference="drivers" link="show">
          <ReferenceField source="userId" reference="users" link={false}>
            <TextField source="name" />
          </ReferenceField>
        </ReferenceField>
        <ReferenceField source="educationSchoolId" reference="education-schools" link={false}>
          <TextField source="name" />
        </ReferenceField>
        <TextField source="programTitle" />
        <TextField source="schoolNameOther" label="Custom School" />
        <DateField source="completedDate" />
        <StatusField />
        <DateField source="createdAt" />
        <EditButton />
        <DeleteButton />
      </Datagrid>
    </List>
  </PageWrapper>
);